// extracted by mini-css-extract-plugin
export default {"manage-table-tabs-wrapper":"TabEmployeesPositions_manage-table-tabs-wrapper__6BBiy"};